module.exports = __webpack_public_path__ + "static/media/What-we-offer.26c58e6f.pptx";